import { render, staticRenderFns } from "./points_task_activity.vue?vue&type=template&id=7a5917b4&scoped=true"
import script from "./points_task_activity.vue?vue&type=script&lang=js"
export * from "./points_task_activity.vue?vue&type=script&lang=js"
import style0 from "./points_task_activity.vue?vue&type=style&index=0&id=7a5917b4&prod&lang=scss&scoped=true"
import style1 from "./points_task_activity.vue?vue&type=style&index=1&id=7a5917b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5917b4",
  null
  
)

export default component.exports